import { gsap } from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Sponsor tiers
 * Slug: sponsor_tiers
 */

function animateSlides(slides) {
	gsap.from(slides, {
		autoAlpha: 0,
		y: -20,
		stagger: 0.1,
	});
}

document.addEventListener("DOMContentLoaded", function () {
	const layouts = document.querySelectorAll(
		".flex-layout.sponsor_tiers-layout",
	);

	layouts.forEach((layout) => {
		const buttons = layout.querySelectorAll(".swiper-buttons button");
		const swiperEl = layout.querySelector(".sponsor-swiper");
		if (!swiperEl) return;

		const wrapper = swiperEl.querySelector(".swiper-wrapper");
		const slideGroups = new Map();

		wrapper.querySelectorAll(".sponsor-card").forEach((slide) => {
			const tier = slide.dataset.tier;
			const tierSlides = slideGroups.get(tier) ?? [];
			tierSlides.push(slide.cloneNode(true));
			slideGroups.set(tier, tierSlides);
		});

		const activeTier = layout.querySelector(".tier-button.active")?.dataset.tier;
		wrapper.replaceChildren(...(slideGroups.get(activeTier) ?? []));

		const swiper = new Swiper(swiperEl, {
			spaceBetween: 16,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: "Vorige sponsor",
				nextSlideMessage: "Volgende sponsor",
				slideLabelMessage: "Sponsor {{index}} van {{slidesLength}}",
			},
			breakpoints: {
				0: {
					slidesPerView: 1.1,
				},
				768: {
					slidesPerView: 2,
				},
				993: {
					slidesPerView: 3,
				},
			},
		});

		animateSlides(swiper.slides);

		buttons.forEach((button, index) => {
			button.addEventListener("click", () => {
				const selectedTier = button.dataset.tier;
				wrapper.replaceChildren(
					...(slideGroups.get(selectedTier) ?? []).map((slide) => slide.cloneNode(true)),
				);
				swiper.update();
				swiper.slideTo(0, 0);

				buttons.forEach((btn, i) => {
					const isActive = i === index;
					btn.classList.toggle("active", isActive);
					btn.setAttribute("aria-pressed", String(isActive));
				});

				animateSlides(swiper.slides);
			});
		});
	});
});
